import React, { Fragment, useState, useEffect, useRef } from 'react'
import cx from 'classnames'
import styles from './Transmission.scss'

// Blue - general event - new entity/ new reservation
// Red - non filer
// Yellow - under report
const allowedTypes = ['regular', 'nonFiler', 'underReport'] as const
const [TYPE_REGULAR] = allowedTypes

type TransmissionType = typeof allowedTypes[number]

/**
 * Dan Abramov's useInterval hook from
 * https://overreacted.io/making-setinterval-declarative-with-react-hooks/
 * Thanks Dan!
 */
function useInterval(callback: () => void, delay: number | null) {
  const savedCallback = useRef<() => void>()

  useEffect(() => {
    savedCallback.current = callback
  }, [callback])

  useEffect(() => {
    function tick() {
      savedCallback.current?.()
    }

    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

interface TransmissionProps {
  isReverse?: boolean
  type?: TransmissionType
  speed?: number
  coordinates: [number, number][]
}

const Transmission: React.FC<TransmissionProps> = ({ 
  isReverse = false, 
  type = TYPE_REGULAR, 
  speed = 60, 
  coordinates 
}) => {
  const [coordinatesIndex, setCoordinatesIndex] = useState(0)

  const [opacity, setOpacity] = useState(1)
  const [opacityDelta, setOpacityDelta] = useState(0.05)

  useInterval(() => {
    const nextIndex = coordinatesIndex + 1
    setCoordinatesIndex(nextIndex)

    const nextOpacity = opacity - opacityDelta
    if (nextOpacity <= 0.9 || nextOpacity >= 1) setOpacityDelta(opacityDelta * -1)

    setOpacity(nextOpacity)
  }, speed)

  return (
    <>
      {[0, 1, 2, 3].map(delta => {
        const currentIndex = isReverse ? coordinates.length - (coordinatesIndex + delta) : coordinatesIndex + delta

        if (currentIndex < 0 || currentIndex >= coordinates.length) return null

        const currentCoordinates = coordinates[currentIndex]
        const [currentCoordinateX, currentCoordinateY] = currentCoordinates

        if (!currentCoordinateX || !currentCoordinateY) return null

        return (
          <div
            key={delta}
            className={cx(styles.transmission, styles[`delta-${delta}`], styles[type])}
            style={{
              left: currentCoordinateX,
              top: currentCoordinateY,
              opacity,
            }}
          >
            <div className={cx(styles.inner, styles[`delta-${delta}`])} />
          </div>
        )
      })}
    </>
  )
}

export default Transmission

